import clsx from "clsx";
import React from "react";
import { Experience } from "types";
import { getDefaultPrice } from "../../models/Experience";
import { AutoTooltipContainer } from "../Common/AutoTooltipContainer";
import { Currency } from "../Common/Currency";
import { NoTranslate } from "../Common/NoTranslate";
import { ProductImage } from "../Common/ProductImage";

interface ProductSummaryTileProps {
    experience: Experience;
    className?: string;
    onClick?: () => void;
}

export const ExperienceSummaryTile = ({ experience, className, onClick }: ProductSummaryTileProps) => {
    return (
        <div className={clsx(className, "flex rounded-lg bg-gray-lighter p-4")} onClick={onClick}>
            <ProductImage size="small" product={experience} />

            <div className="overflow-x-hidden">
                <NoTranslate as="div" data-testid="experience-summary-tile-name">
                    <AutoTooltipContainer tooltipContent={<NoTranslate>{experience.name}</NoTranslate>}>
                        <div className="truncate font-bold">
                            <NoTranslate>{experience.name}</NoTranslate>
                        </div>
                    </AutoTooltipContainer>
                </NoTranslate>
                <div className="text-gray-darker" data-testid="experience-summary-tile-price">
                    From <Currency>{getDefaultPrice(experience)}</Currency>
                </div>
            </div>
        </div>
    );
};
